import { withFormik } from "formik";
import * as Yup from "yup";

const itemSchema = Yup.object().shape({
  fileType: Yup.string()
    .oneOf(["IMAGE", "TEXT", "IMAGE_TEXT"], "Invalid slide type")
    .required("Slide type is required"),
  text: Yup.string().when("fileType", {
    is: val => val === "TEXT" || val === "IMAGE_TEXT",
    then: Yup.string()
      .trim()
      .required("Text is required"),
    otherwise: Yup.string().notRequired()
  }),
  imageWidth: Yup.number()
    .nullable()
    .min(1, "Width must be at least 1px"),
  imageHeight: Yup.number()
    .nullable()
    .min(1, "Height must be at least 1px")
});

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    device: Yup.mixed()
      .required("Device is required")
      .nullable(),
    items: Yup.array()
      .of(itemSchema)
      .min(1, "Add at least one scroller slide")
  }),
  mapPropsToValues: props => {
    const items = [];
    if (props.editedData?.advertisementResDTOSet?.length) {
      const raw = props.editedData.advertisementResDTOSet;
      const list = Array.isArray(raw) ? raw : [...raw];
      list
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .forEach(ad => {
          const inferredType =
            ad.fileType ||
            (ad.advertisement && ad.advertisement.startsWith("http")
              ? ad.overlayText
                ? "IMAGE_TEXT"
                : "IMAGE"
              : "TEXT");
          items.push({
            advertisementId: ad.advertisementId,
            fileType: inferredType,
            text:
              inferredType === "TEXT"
                ? ad.advertisement || ""
                : ad.overlayText || "",
            imageUrl:
              inferredType === "IMAGE" || inferredType === "IMAGE_TEXT"
                ? ad.advertisement
                : "",
            imageWidth: ad.imageWidth || "",
            imageHeight: ad.imageHeight || "",
            file: null
          });
        });
    }
    return {
      device: props.editedData
        ? {
            label: props.editedData.email,
            value: props.editedData.email,
            id: props.editedData.deviceTokenId
          }
        : "",
      items: items.length
        ? items
        : [
            {
              advertisementId: null,
              fileType: "IMAGE",
              text: "",
              imageUrl: "",
              imageWidth: "",
              imageHeight: "",
              file: null
            }
          ],
      deletedAdvertisementIds: []
    };
  },
  handleSubmit: values => {},
  displayName: "AdvertisementValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;

export const SCROLLER_RECOMMENDED = { width: 1280, height: 102 };
